export * from "./get-logo";
